/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontEndSelectValue
 */
export interface FrontEndSelectValue {
    /**
     * 
     * @type {string}
     * @memberof FrontEndSelectValue
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof FrontEndSelectValue
     */
    value?: string;
}

/**
 * Check if a given object implements the FrontEndSelectValue interface.
 */
export function instanceOfFrontEndSelectValue(value: object): value is FrontEndSelectValue {
    return true;
}

export function FrontEndSelectValueFromJSON(json: any): FrontEndSelectValue {
    return FrontEndSelectValueFromJSONTyped(json, false);
}

export function FrontEndSelectValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontEndSelectValue {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function FrontEndSelectValueToJSON(json: any): FrontEndSelectValue {
    return FrontEndSelectValueToJSONTyped(json, false);
}

export function FrontEndSelectValueToJSONTyped(value?: FrontEndSelectValue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'value': value['value'],
    };
}

